<template>
  <v-lazy>
    <v-chip-group column>
      <div class="text-body-1 mr-2 mt-2">Filed under</div>
      <v-chip
        v-for="type in value.resource_types.filter(
          ({ position }) => position > -1
        )"
        :key="`type-${type.id}`"
        :href="`/resources?type=${type.id}`"
      >
        {{ type.name }}
      </v-chip>

      <v-chip
        v-for="topic in value.resource_topics.filter(
          ({ position }) => position > -1
        )"
        :key="`topic-${topic.id}`"
        :href="`/resources?topic=${topic.id}`"
      >
        {{ topic.name }}
      </v-chip>

      <v-chip
        v-for="course in value.courses"
        :key="`course-${course.id}`"
        :href="`/resources?course=${course.id}`"
      >
        {{ course.name }}
      </v-chip>
    </v-chip-group>
  </v-lazy>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
